import React, {Component} from 'react';
import hello from 'hellojs';

export default class GoogleLogin extends Component
{
    constructor(props) {
        super(props);
        this.state = {
            lang: 'zh_cn',
        }
    }

    componentDidMount() {}

    render() {
        return (
            <article className='page-google'>
                <div className="loading">
                    <span>&bull;</span>
                    <span>&bull;</span>
                    <span>&bull;</span>
                </div>
                <div className='pg-logging'>login......</div>
            </article>
        )
    }
}
